import { PopupError } from "@components/general/popup";
import { usePageHeader } from "@hooks/use_page_header";
import { linkPage } from "@utils/router";
import { useState } from "react";
import {
  LuAlertTriangle,
  LuBookMarked,
  LuBookOpen,
  LuCalendarCheck,
  LuCalendarDays,
  LuClipboardList,
  LuCoins,
  LuCreditCard,
  LuFileBarChart,
  LuFileText,
  LuHeartPulse,
  LuSettings2,
  LuStore,
  LuTrophy,
  LuUser,
  LuWallet,
} from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const MenuItem = ({
  onClick,
  bg,
  color,
  Icon,
  label,
}: {
  onClick: () => void;
  bg: string;
  color: string;
  Icon: React.ElementType;
  label: string;
}) => (
  <div className="tw-mx-2 tw-pb-2 card-grid">
    <div onClick={onClick} className="tw-m-0">
      <div
        className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-1.5 tw-rounded-2xl tw-w-[44px] tw-h-[44px]"
        style={{ background: bg }}
      >
        <Icon className="tw-text-xl" style={{ color }} />
      </div>
      <div className="tw-line-clamp-1 card-name">{label}</div>
    </div>
  </div>
);

const SectionHeader = ({ title }: { title: string }) => (
  <div className="tw-px-1 tw-mb-1 tw-mt-5 tw-flex tw-items-center tw-gap-2">
    <div className="tw-w-1 tw-h-4 tw-rounded-full tw-bg-primary tw-shrink-0" />
    <span className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-widest tw-text-text-tertiary">
      {title}
    </span>
  </div>
);

export const MenuPage = () => {
  const navigate = useNavigate();
  usePageHeader("Menu", { bottomNavigation: "hidden" });
  const [popupError, setPopupError] = useState<boolean>(false);

  return (
    <>
      <div className="tw-pb-8 tw-px-4 tw-pt-2">
        <SectionHeader title="Sekolah" />
        <div className="card-body-grid">
          <MenuItem
            onClick={() => navigate(linkPage.INFO_BIOGRAPH)}
            bg="#f0fdf4"
            color="#22c55e"
            Icon={LuUser}
            label="Biodata"
          />
          <MenuItem
            onClick={() => navigate(linkPage.HEALTH_PAGE)}
            bg="#ecfdf5"
            color="#10b981"
            Icon={LuHeartPulse}
            label="Info UKP"
          />
          <MenuItem
            onClick={() => navigate(linkPage.ABSENCE_PAGE)}
            bg="#f1f5f9"
            color="#64748b"
            Icon={LuClipboardList}
            label="Absensi"
          />
          <MenuItem
            onClick={() => navigate(linkPage.VIOLATION_PAGE)}
            bg="#fff1f2"
            color="#ef4444"
            Icon={LuAlertTriangle}
            label="Pelanggaran"
          />
          <MenuItem
            onClick={() => navigate(linkPage.ACHIEVEMENT_PAGE)}
            bg="#fffbeb"
            color="#f59e0b"
            Icon={LuTrophy}
            label="Prestasi"
          />
        </div>

        <SectionHeader title="Tahfidz" />
        <div className="card-body-grid">
          <MenuItem
            onClick={() => navigate("/school/tahfidz")}
            bg="#ecfdf5"
            color="#0d9488"
            Icon={LuBookOpen}
            label="Tahfidz"
          />
          <MenuItem
            onClick={() => navigate("/school/tafaquh")}
            bg="#f5f3ff"
            color="#7c3aed"
            Icon={LuBookMarked}
            label="Tafaquh"
          />
        </div>

        <SectionHeader title="Toko" />
        <div className="card-body-grid">
          <MenuItem
            onClick={() => navigate(linkPage.MARKETPLACE_PRODUCT)}
            bg="#fff7ed"
            color="#f97316"
            Icon={LuStore}
            label="Toko"
          />
          <MenuItem
            onClick={() => navigate(linkPage.MARKETPLACE_SETTING)}
            bg="#f1f5f9"
            color="#64748b"
            Icon={LuSettings2}
            label="Atur Limit"
          />
        </div>

        <SectionHeader title="Tagihan" />
        <div className="card-body-grid">
          <MenuItem
            onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)}
            bg="#fff1f2"
            color="#ef4444"
            Icon={LuCalendarDays}
            label="Bulanan"
          />
          <MenuItem
            onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)}
            bg="#fff7ed"
            color="#f97316"
            Icon={LuFileText}
            label="Non Bulanan"
          />
        </div>

        <SectionHeader title="Pembayaran" />
        <div className="card-body-grid">
          <MenuItem
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "bill"), {
                state: { tagihan: true, tipe: "bill" },
              })
            }
            bg="#f0fdf4"
            color="#166534"
            Icon={LuCreditCard}
            label="Request VA"
          />
          {/* <MenuItem
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"), {
                state: { tagihan: false, tipe: "zis" },
              })
            }
            bg="#f0fdf4"
            color="#22c55e"
            Icon={LuCoins}
            label="VA ZIS"
          /> */}
          <MenuItem
            onClick={() => navigate("/finance/data-va")}
            bg="#f1f5f9"
            color="#64748b"
            Icon={LuFileBarChart}
            label="Laporan VA"
          />
          <MenuItem
            onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
            bg="#f0fdf4"
            color="#166534"
            Icon={LuWallet}
            label="Uang Saku"
          />
        </div>

        <SectionHeader title="Perizinan" />
        <div className="card-body-grid">
          <MenuItem
            onClick={() => navigate(linkPage.PERMIT_PAGE)}
            bg="#fff1f2"
            color="#f43f5e"
            Icon={LuCalendarCheck}
            label="Request Izin"
          />
          <MenuItem
            onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)}
            bg="#f1f5f9"
            color="#64748b"
            Icon={LuClipboardList}
            label="Laporan"
          />
        </div>
      </div>

      <PopupError
        open={popupError}
        title="Fitur Tidak Tersedia"
        message="Fitur ini sedang dalam perbaikan. Kami akan segera mengaktifkannya kembali."
        textConfirm="Tutup"
        onConfirm={() => setPopupError(false)}
      />
    </>
  );
};
